import { getScriptData } from './utils.m.js';

const data = getScriptData(import.meta.url);

class KundendatenAboLogin {
	constructor(baseUrl, loginVorhanden) {
		document.getElementById('neukunde-tab').addEventListener('click', () => {
			window.location.href = `${baseUrl}/KundendatenAboLogin/Neukunde`;
		});
		if (loginVorhanden) {
			$('#Kennwort').trigger('focus');
		}
	}
}

new KundendatenAboLogin(data.baseUrl, data.loginVorhanden);
